import React from 'react';
import './OpportunityIndicators.css';

const OpportunityIndicators = ({ opportunities = [], className = '' }) => {
  if (!opportunities || opportunities.length === 0) {
    return null;
  }

  const getIndicatorConfig = (opportunity) => {
    // Helper function to safely convert string to number
    const toNumber = (value) => {
      if (value === null || value === undefined) return null;
      return typeof value === 'string' ? parseFloat(value) : value;
    };

    switch (opportunity.opportunity_type) {
      case 'volume_spike':
        const volumeChange = toNumber(opportunity.volume_change_24h);
        return {
          icon: '🔥',
          label: 'Volume Spike',
          className: 'volume-spike',
          description: volumeChange !== null ? `${volumeChange.toFixed(0)}% volume increase` : 'Volume spike detected'
        };
      case 'price_breakout':
        const priceChange = toNumber(opportunity.price_change_1h);
        return {
          icon: '📈',
          label: 'Breakout',
          className: 'price-breakout',
          description: priceChange !== null ? `${Math.abs(priceChange).toFixed(1)}% price move` : 'Price breakout detected'
        };
      case 'trend_reversal':
        return {
          icon: '🔄',
          label: 'Reversal',
          className: 'trend-reversal',
          description: 'Trend reversal detected'
        };
      case 'social_buzz':
        return {
          icon: '📢',
          label: 'Social Buzz',
          className: 'social-buzz',
          description: 'High social activity'
        };
      default:
        return {
          icon: '⭐',
          label: 'Opportunity',
          className: 'generic',
          description: opportunity.description || 'Trading opportunity'
        };
    }
  };

  const getConfidenceColor = (score) => {
    const numScore = typeof score === 'string' ? parseFloat(score) : score;
    if (numScore >= 0.8) return 'high';
    if (numScore >= 0.6) return 'medium';
    return 'low';
  };

  return (
    <div className={`opportunity-indicators ${className}`}>
      {opportunities.map((opportunity, index) => {
        const config = getIndicatorConfig(opportunity);
        const confidenceLevel = getConfidenceColor(opportunity.confidence_score);
        
        const confidenceScore = typeof opportunity.confidence_score === 'string' ?
          parseFloat(opportunity.confidence_score) : opportunity.confidence_score;
        const confidencePercent = confidenceScore ? (confidenceScore * 100).toFixed(0) : '0';

        return (
          <div
            key={`${opportunity.id || index}-${opportunity.opportunity_type}`}
            className={`opportunity-indicator ${config.className} confidence-${confidenceLevel}`}
            title={`${config.description} (${confidencePercent}% confidence)`}
          >
            <span className="indicator-icon">{config.icon}</span>
            <span className="indicator-label">{config.label}</span>
            <div className="confidence-bar">
              <div
                className="confidence-fill"
                style={{ width: `${confidenceScore * 100}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default OpportunityIndicators;